'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _VstComponent2 = require('./VstComponent');

var _VstComponent3 = _interopRequireDefault(_VstComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VstHamburger = function (_VstComponent) {
  _inherits(VstHamburger, _VstComponent);

  function VstHamburger() {
    _classCallCheck(this, VstHamburger);

    var _this = _possibleConstructorReturn(this, (VstHamburger.__proto__ || Object.getPrototypeOf(VstHamburger)).call(this));

    _this._clickHamburger = _this._clickHamburger.bind(_this);
    return _this;
  }

  _createClass(VstHamburger, [{
    key: '_clickHamburger',
    value: function _clickHamburger(e) {
      if (this.props.clickHamburger) {
        this.props.clickHamburger(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'button',
        { className: 'hamburger vst-no-button',
          onClick: this._clickHamburger,
          'aria-expanded': this.props.active
        },
        _react2.default.createElement(
          'span',
          { className: 'vst-off-screen' },
          'Hambuggler'
        )
      );
    }
  }]);

  return VstHamburger;
}(_VstComponent3.default);

exports.default = VstHamburger;


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/components/VstHamburger.js
 **/